import { IIsiUIFlowRejectReason } from "./IIsiUIFlowRejectReason";

/**
 * Object représentant la rejection d'une promise. Cet objet doit être passé en paramètre de la méthode reject
 **/
export class IsiUIFlowRejectReason implements IIsiUIFlowRejectReason {

    private _reason: string;

    constructor(reason: string) {
        this._reason = reason;
    }

    /**
     * La raison de la rejection
     **/
    get reason() {
        return this._reason;
    }

}